import * as React from "react";
import { Slot } from "radix-ui";
import { cva } from "class-variance-authority";
import { cn } from "src/utils/cn";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default:     "bg-slate-900 text-white hover:bg-slate-800",
        destructive: "bg-red-500 text-white hover:bg-red-600",
        outline:     "border border-slate-300 bg-white text-slate-900 hover:bg-slate-100",
        secondary:   "bg-slate-100 text-slate-900 hover:bg-slate-200",
        ghost:       "text-slate-700 hover:bg-slate-100 hover:text-slate-900",
        link:        "text-slate-900 underline-offset-4 hover:underline",
        success:     "bg-emerald-500 text-white hover:bg-emerald-600",
        brand:       "bg-[#4f39f6] text-white hover:bg-[#4332d6]",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm:      "h-8 rounded-md px-3 text-xs",
        lg:      "h-11 rounded-md px-8",
        icon:    "h-8 w-8 rounded-md",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

function Button({ className, variant, size, asChild = false, ...props }) {
  const Comp = asChild ? Slot.Root : "button";
  return (
    <Comp className={cn(buttonVariants({ variant, size, className }))} {...props} />
  );
}

export { Button, buttonVariants };
